<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/means/index' }">资产管理</el-breadcrumb-item>
      <el-breadcrumb-item>资产{{ form.id <= 0 ? '添加' : '编辑'}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content">
        <el-form :model="form" ref="ruleForm" :rules="rules" label-width="160px">
          <el-form-item label="网站地址" prop="domain">
            <el-col :span="12">
              <el-input size="small" v-model="form.domain" placeholder="请输入网站地址"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="网站分类" prop="cate_id">
            <el-col :span="12">
              <el-select
                size="small"
                v-model="form.cate_id"
                placeholder="请选择分类"
                style="width: 100%;"
              >
                <el-option
                  v-for="(item, index) in categories"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="用户帐号" prop="account">
            <el-col :span="12">
              <el-input size="small" v-model="form.account" placeholder="请输入用户帐号"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-col :span="12">
              <el-input type="password" size="small" v-model="form.password" placeholder="请输入帐号密码"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="是否付费" prop="is_pay">
            <el-switch v-model="form.is_pay"></el-switch>
          </el-form-item>
          <template v-if="form.is_pay">
            <el-form-item  label="收费价格" prop="price">
              <el-col :span="12">
                <el-input size="small" v-model="form.price" placeholder="请输入收费价格">
                  <template slot="append">元</template>
                </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="过期时间" prop="expired_at">
              <el-date-picker
                v-model="form.expired_at"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="自动续费" prop="auto_renew">
              <el-switch v-model="form.auto_renew"></el-switch>
            </el-form-item>
            <el-form-item v-if="form.auto_renew" label="续费时长" prop="month">
              <el-col :span="12">
                <el-input size="small" v-model="form.month" placeholder="月份">
                  <template slot="append">月</template>
                </el-input>
              </el-col>
            </el-form-item>
          </template>
          
          <el-form-item label="备注">
            <el-col :span="12">
              <el-input type="textarea" v-model="form.remark" placeholder="请输入备注"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary" @click="save">保存</el-button>
            <el-button size="small" @click="$router.go(-1)">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        id: "",
        account: "",
        password: "",
        domain: '',
        cate_id: '',
        is_pay:0,
        expired_at: '',
        month: '',
        auto_renew: 0,
        remark: '',
        price: '',
      },
      categories: [],
      rules: {
        domain: [
          { required: true, message: '请输入网站域名', trigger: 'blur' },
          { min: 1, max: 255, message: '长度在1到255个字符', trigger: 'blur' }
        ],
        cate_id: [
          { required: true, message: '请选择对应的网站分类', trigger: 'change' }
        ],
        account: [
          { required: true, message: '请输入网站帐号', trigger: 'blur' },
          { min: 1, max: 255, message: '长度在1到255个字符', trigger: 'blur' }
        ],
        password: [
        { required: true, message: '请输入账户密码', trigger: 'blur' },
          { min: 0, max: 255, message: '长度在0到255个字符', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入备注信息', trigger: 'change' },
          { min: 1, max: 255, message: '长度在1到255个字符', trigger: 'blur' }
        ],
      }
    };
  },
  methods: {
    loadCategory() {
      this.$ajax({
        url: "/constant/category",
      }).then(data => {
        this.categories = data.data;
      });
    },
    loadMember() {
      var id = this.$route.query ? this.$route.query.id : 0;
      if(!id) {
        return 0
      }

      this.$ajax({
        url: "/accounts/one?id=" + id,
        type:"GET",
      }).then(res => {
        this.form = {
          id: res.data.id,
          account: res.data.account,
          password: res.data.password,
          domain: res.data.domain,
          cate_id: res.data.cate_id,
          is_pay: res.data.is_pay ? true : false,
          expired_at: res.data.expired_at,
          month: res.data.month,
          auto_renew: res.data.auto_renew ? true : false,
          remark: res.data.remark,
          price: res.data.price,
        }
      });
    },
    save() {
      let form = this.form;
      this.$refs.ruleForm.validate((valid) => {
        if(!valid) {
          return false;
        }

        // 开始处理loading.
        var loading = this.$loading({
          lock: true,
          text: '保存中...',
          spinner: 'el-icon-loading',
          background: 'hsla(0,0%,100%,.9)',
        });

        this.$ajax({
          type: 'POST',
          url: '/accounts/save',
          data: form,
        }).then((res) => {
          loading.close()
          if(res.code != 200) {
            return this.$util.msg(res.msg, "error");
          }
          
          this.$util.msg(res.msg, "success");

          setTimeout(() => {
            this.$router.push({ path: "/means/index" });
          });
        })
      });

      return false;
    }
  },
  mounted() {
    this.loadCategory()
    this.loadMember()
  }
};
</script>
<style>
</style>